/*  eslint-disable react/no-unescaped-entities */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleUp, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <div id="about">
      <div className="app__headerAUS app__aboutus flex__center section__padding">
        <div className="app__aboutus-content flex__center">

          {/* MISSION */}
          <div className="app__aboutus-content_about">
            <h1 className="headtext__cormorant">Engineering Mandate</h1>
            <p className="p__opensans" style={{ lineHeight: '1.7' }}>
              CurvSort develops intelligent application frameworks and distributed infrastructure
              systems spanning both on-device and cloud execution environments. By optimizing
              models for native acceleration on consumer hardware and building observability
              architectures for modern AI workloads, we maintain engineering rigor across every
              production layer.
            </p>
            <div className="app__header_buttons">
              <FontAwesomeIcon
                onClick={() => { navigate('/'); window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }}
                className="angleUpLogo"
                icon={faAngleDoubleUp}
              />
            </div>
          </div>

          <div className="app__aboutus-content_knife flex__center">
            <div className="app__aboutus-vertical_line" />
          </div>

          {/* OPERATIONAL BACKGROUND */}
          <div className="app__aboutus-content_history">
            <h1 className="headtext__cormorant">Technical Leadership</h1>
            <p className="p__opensans" style={{ lineHeight: '1.7' }}>
              Our foundation builds upon two decades of scaling large-scale core architectures within world-class enterprise
              environments. CurvSort&apos;s technical direction integrates proven execution principles honed at industry leaders
              including Synopsys, Yahoo, NetApp, Zynga, VMware, and Groupon, combined with advanced systems research and
              engineering foundations from Indian Institute of Technology, Delhi.
              {' '}
              <a href="https://www.linkedin.com/in/rajeev-bakshi-10bb2a5/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="app__aboutus-linkedin">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </p>
            <div className="app__aboutus-footer-row">
              <div className="app__aboutus-social">
                <a href="/foundations" className="app__aboutus-foundations-link">
                  Foundations <FontAwesomeIcon icon={faArrowRight} className="app__aboutus-foundations-arrow" />
                </a>
              </div>
              <div className="app__aboutus-scroll-top">
                <FontAwesomeIcon
                  onClick={() => { navigate('/'); window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }}
                  className="angleUpLogo"
                  icon={faAngleDoubleUp}
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutUs;
